import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useTypedSelector } from "../store"
import { AuthState } from "../store/actions/auth"
import { RootState } from "../store/reducers"

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
	const auth: AuthState = useTypedSelector((state: RootState) => state.auth)
	const isOTPRequired: boolean = auth.isOtpRequired
	const isLoggedUser: boolean = auth.isAuthenticate
	const isResetPassword: boolean = auth.user?.userPasswordReset ?? false
	const resetToken: string = auth.user?.resetToken ?? ""

	if (isOTPRequired) {
		return <Navigate to="/otp" />
	} else if (isResetPassword) {
		return <Navigate to={`/change-password?resetToken=${resetToken}`} />
	} else if (!isLoggedUser) {
		return <Navigate to="/login" />
	}

	return children
}

export default ProtectedRoute
